module.exports = __webpack_public_path__ + "static/img/guide4.2e041a5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide4.webp
// module id = mfFP
// module chunks = 1